import { checkpointSchema, syncEntityIdSchema } from './schemas';
import { z } from 'zod/v4';

export const processItemSummaryDocSchema = z.object({
  commentCount: z.number().int().min(0),
  incompleteTodoCount: z.number().int().min(0),
  itemChangeCheckpoint: checkpointSchema.nullable(),
  lastActivityAt: z.iso.datetime(),
  processId: syncEntityIdSchema,
  todoCount: z.number().int().min(0),
  totalItemCount: z.number().int().min(0),
  updatedAt: z.iso.datetime(),
});

export type ProcessItemSummaryDoc = z.infer<typeof processItemSummaryDocSchema>;
